import {Component} from 'react';
import Marquee from "react-fast-marquee";
import SvgMegaphone from "./icons/SvgMegaphone";

class CampaignBanner extends Component {
    render() {
        return (
            <Marquee className='bg-primary'>
                <div onClick={() => this.props.navigateTo({pathname: `/authentication`})}
                     className={'row-ac pointer pv-8 bg-white-10-h'}>
                    {/* <div className='row-ac' style={{marginRight: '20vw'}}>
                        <SvgMegaphone style={{color: 'white'}} width={24} height={24}/>
                        <p className='title2 ml-8' style={{color: 'white'}}>
                            Join the Land of the Free Military Support Campaign!
                        </p>
                    </div> */}
                    <div className='row-ac' style={{marginRight: '20vw'}}>
                        <SvgMegaphone style={{color: 'white'}} width={24} height={24}/>
                        <p className='title2 ml-8' style={{color: 'white'}}>
                        Starfish is the global platform to showcase your humanitarian profile and build your GOOD NETWORK.
                        </p>
                    </div>
                    {/* <div className='row-ac' style={{marginRight: '20vw'}}>
                        <SvgMegaphone style={{color: 'white'}} width={24} height={24}/>
                        <p className='title2 ml-8' style={{color: 'white'}}>
                            Starfish is the global social network designed to promote and share your good with the world
                        </p>
                    </div> */}
                    {/* <div className='row-ac' style={{marginRight: '20vw'}}>
                        <SvgMegaphone style={{color: 'white'}} width={24} height={24}/>
                        <p className='title2 ml-8' style={{color: 'white'}}>
                            Join Starfish today and we'll make a donation to BinghamtonU in your name
                        </p>
                    </div> */}
                </div>
            </Marquee>
        )
    }
}

export default CampaignBanner
